import { IconWand, IconWandOff } from '@tabler/icons-react';
import { Button, Switch, Tooltip } from '@/components/ui';

interface AutoMappingToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
}

/**
 * AutoMappingToggle - Switch for enabling/disabling automatic mapping
 *
 * Allows users to control whether the system should automatically
 * detect forms and map columns when files are selected.
 */
export const AutoMappingToggle: React.FC<AutoMappingToggleProps> = ({
  enabled,
  onChange,
  disabled = false,
}) => {
  return (
    <Tooltip
      content={
        enabled
          ? 'Auto-mapping enabled: System will automatically detect forms and map columns'
          : 'Auto-mapping disabled: You will manually select forms and map columns'
      }
      side="top"
    >
      <Button
        size="small"
        variant="outlined"
        color={enabled ? 'primary' : 'default'}
        as="label"
        onClick={() => {
          onChange(!enabled);
        }}
        startIcon={enabled ? <IconWand /> : <IconWandOff />}
        endIcon={
          <Switch
            checked={enabled}
            color={enabled ? 'primary' : 'default'}
            onCheckedChange={onChange}
            disabled={disabled}
            size="small"
          />
        }
      >
        Auto-mapping {enabled ? 'enabled' : 'disabled'}
      </Button>
    </Tooltip>
  );
};
